export enum TaskFormKeyEnum {
  BuyerRequest = 'buyer_request',
  BuyerRequestEdit = 'buyer_request_edit',
  BuyerRequestComment = 'buyer_request_comment',
  BuyerRequestApproval = 'buyer_request_approval',
  BuyerRequestComplianceApproval = 'buyer_request_compliance_approval',
  BuyerRequestApprovalEdit = 'buyer_request_approval_edit',
  BuyerRequestDelegateSingle = 'buyer_request_delegate_single',
  BuyerRequestDelegate = 'buyer_request_delegate',
}
